<template>
  <div class="registration registration--mainView">
    <v-app id="registrationView">
      <div v-if="current_step == 0" class="step start-step">
        <header class="registration__head">
          <div class="main-header__logo">
            <a href="/"><img src="/img/welcome/logos/doffero-logo-v2.svg" alt="Doffero" /></a>
          </div>
        </header>

        <div class="registration__content">
          <aside class="registration__side">
            <div class="side-top">
              <!--??? <header>
                <h2 class="side-top__title">
                {{ $t("other_woutlog.register_text_2") }}
                Už žiadne nudné cenové ponuky
                </h2>
            </header> -->

              <h1 class="main-title">
                {{ /*$t("other_woutlog.register_text_19") */ }}
                Nastav si DOFFERO na komplet za menej ako 90 sekúnd
              </h1>
              <p class="main-subtext">
                {{ /*$t("other_woutlog.register_text_20") */ }}
                Vďaka tomu budeš vytvárať cenové ponuky rýchlo a jednoducho.
                Začni menom, e-mailom a heslom.
              </p>

              <form class="form form--registration" method="POST" action="/registracia">
                <input type="hidden" name="_token" :value="csrf" />
                <div class="form-group" :class="errors.meno_priezvisko ? 'has-error' : ''">
                  <div class="input-wrapper email">
                    <label class="form__label" for="meno_priezvisko">{{
                      $t("other_woutlog.register_text_22")
                    }}</label>
                    <input v-model="user.meno_priezvisko" class="form__input" type="text" name="meno_priezvisko"
                      id="meno_priezvisko" />
                  </div>
                  <div v-if="errors.meno_priezvisko" class="form-error registrationError">
                    <svg width="16" height="14" viewBox="0 0 16 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path fill-rule="evenodd" clip-rule="evenodd"
                        d="M6.25709 1.099C7.02209 -0.260998 8.97909 -0.260998 9.74309 1.099L15.3231 11.019C16.0731 12.353 15.1101 13.999 13.5811 13.999H2.42009C0.890093 13.999 -0.0729075 12.353 0.677092 11.019L6.25709 1.099ZM9.00009 11C9.00009 11.2652 8.89474 11.5196 8.7072 11.7071C8.51966 11.8946 8.26531 12 8.00009 12C7.73488 12 7.48052 11.8946 7.29299 11.7071C7.10545 11.5196 7.00009 11.2652 7.00009 11C7.00009 10.7348 7.10545 10.4804 7.29299 10.2929C7.48052 10.1054 7.73488 10 8.00009 10C8.26531 10 8.51966 10.1054 8.7072 10.2929C8.89474 10.4804 9.00009 10.7348 9.00009 11ZM8.00009 3C7.73488 3 7.48052 3.10536 7.29299 3.2929C7.10545 3.48043 7.00009 3.73479 7.00009 4V7C7.00009 7.26522 7.10545 7.51957 7.29299 7.70711C7.48052 7.89465 7.73488 8 8.00009 8C8.26531 8 8.51966 7.89465 8.7072 7.70711C8.89474 7.51957 9.00009 7.26522 9.00009 7V4C9.00009 3.73479 8.89474 3.48043 8.7072 3.2929C8.51966 3.10536 8.26531 3 8.00009 3Z"
                        fill="#E83C58" />
                    </svg>
                    {{ errors.meno_priezvisko }}
                  </div>
                </div>
                <input type="hidden" name="priezvisko" :value="user.priezvisko" />
                <input type="hidden" name="meno" :value="user.meno" />
                <div class="form-group" :class="errors.email ? 'has-error' : ''">
                  <div class="input-wrapper email">
                    <label class="form__label" for="email">{{
                      /* TODO: new email label text
                      $t("other_woutlog.register_text_23")*/

                      }}Emailová adresa</label>
                    <input v-model="user.email" class="form__input" type="email" name="email" id="email" />
                  </div>
                  <div v-if="errors.email" class="form-error registrationError">
                    <svg width="16" height="14" viewBox="0 0 16 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path fill-rule="evenodd" clip-rule="evenodd"
                        d="M6.25709 1.099C7.02209 -0.260998 8.97909 -0.260998 9.74309 1.099L15.3231 11.019C16.0731 12.353 15.1101 13.999 13.5811 13.999H2.42009C0.890093 13.999 -0.0729075 12.353 0.677092 11.019L6.25709 1.099ZM9.00009 11C9.00009 11.2652 8.89474 11.5196 8.7072 11.7071C8.51966 11.8946 8.26531 12 8.00009 12C7.73488 12 7.48052 11.8946 7.29299 11.7071C7.10545 11.5196 7.00009 11.2652 7.00009 11C7.00009 10.7348 7.10545 10.4804 7.29299 10.2929C7.48052 10.1054 7.73488 10 8.00009 10C8.26531 10 8.51966 10.1054 8.7072 10.2929C8.89474 10.4804 9.00009 10.7348 9.00009 11ZM8.00009 3C7.73488 3 7.48052 3.10536 7.29299 3.2929C7.10545 3.48043 7.00009 3.73479 7.00009 4V7C7.00009 7.26522 7.10545 7.51957 7.29299 7.70711C7.48052 7.89465 7.73488 8 8.00009 8C8.26531 8 8.51966 7.89465 8.7072 7.70711C8.89474 7.51957 9.00009 7.26522 9.00009 7V4C9.00009 3.73479 8.89474 3.48043 8.7072 3.2929C8.51966 3.10536 8.26531 3 8.00009 3Z"
                        fill="#E83C58" />
                    </svg>
                    {{ errors.email }}
                    <a v-if="emailExistsError" href="/prihlasenie"
                      style="margin-left: 10px; color: #e83c58; font-size: 14px">Prihlásiť sa</a>
                  </div>
                </div>
                <div class="form-group form-group--last" :class="errors.password ? 'has-error' : ''">
                  <div class="input-wrapper password">
                    <label class="form__label" for="heslo">{{
                      $t("other_woutlog.register_text_24")
                    }}</label>
                    <input v-model="user.password" @focus="focus_password = true" @blur="focus_password = false"
                      class="form__input pass" type="password" name="password" id="heslo" />
                    <div class="password-toggle js-password-show">
                      <svg width="16" class="eye" data-target="#heslo" height="16" fill="none"
                        xmlns="http://www.w3.org/2000/svg">
                        <g clip-path="url(#a)" fill="#F93D36">
                          <path
                            d="M8 1.333C3.232 1.333.268 7.156.14 7.404a1.333 1.333 0 0 0 0 1.192c.127.248 3.091 6.07 7.86 6.07 4.77 0 7.734-5.822 7.867-6.07a1.333 1.333 0 0 0 0-1.192c-.133-.248-3.097-6.07-7.866-6.07ZM8 12c-2.245 0-4.227-2.495-5.135-3.992C3.625 6.768 5.59 4 8 4c2.245 0 4.228 2.496 5.136 3.992C12.377 9.232 10.41 12 8 12Z" />
                          <path d="M8 10a2 2 0 1 0 0-4 2 2 0 0 0 0 4Z" />
                        </g>
                        <defs>
                          <clipPath id="a">
                            <path fill="#fff" d="M0 0h16v16H0z" />
                          </clipPath>
                        </defs>
                      </svg>
                    </div>
                  </div>
                  <div v-if="focus_password" class="password_errors registrationError">
                    <span :class="passowrd_errors.znaky ? 'active' : ''">
                      <svg v-if="!passowrd_errors.znaky" width="16" height="14" viewBox="0 0 16 14" fill="none"
                        xmlns="http://www.w3.org/2000/svg">
                        <path fill-rule="evenodd" clip-rule="evenodd"
                          d="M6.25709 1.099C7.02209 -0.260998 8.97909 -0.260998 9.74309 1.099L15.3231 11.019C16.0731 12.353 15.1101 13.999 13.5811 13.999H2.42009C0.890093 13.999 -0.0729075 12.353 0.677092 11.019L6.25709 1.099ZM9.00009 11C9.00009 11.2652 8.89474 11.5196 8.7072 11.7071C8.51966 11.8946 8.26531 12 8.00009 12C7.73488 12 7.48052 11.8946 7.29299 11.7071C7.10545 11.5196 7.00009 11.2652 7.00009 11C7.00009 10.7348 7.10545 10.4804 7.29299 10.2929C7.48052 10.1054 7.73488 10 8.00009 10C8.26531 10 8.51966 10.1054 8.7072 10.2929C8.89474 10.4804 9.00009 10.7348 9.00009 11ZM8.00009 3C7.73488 3 7.48052 3.10536 7.29299 3.2929C7.10545 3.48043 7.00009 3.73479 7.00009 4V7C7.00009 7.26522 7.10545 7.51957 7.29299 7.70711C7.48052 7.89465 7.73488 8 8.00009 8C8.26531 8 8.51966 7.89465 8.7072 7.70711C8.89474 7.51957 9.00009 7.26522 9.00009 7V4C9.00009 3.73479 8.89474 3.48043 8.7072 3.2929C8.51966 3.10536 8.26531 3 8.00009 3Z"
                          fill="#E83C58" />
                      </svg>
                      <svg v-if="passowrd_errors.znaky" width="26" height="27" viewBox="0 0 26 27" fill="none"
                        xmlns="http://www.w3.org/2000/svg">
                        <rect y="0.5" width="26" height="26" rx="13" fill="#34D399" />
                        <path d="M8.28986 14.1406L10.9814 16.7029L17.7101 10.2971" stroke="white" stroke-width="2"
                          stroke-linecap="round" stroke-linejoin="round" />
                      </svg>
                      {{ $t("other_woutlog.register_text_25") }}
                    </span>
                    <span :class="passowrd_errors.letter ? 'active' : ''">
                      <svg v-if="!passowrd_errors.letter" width="16" height="14" viewBox="0 0 16 14" fill="none"
                        xmlns="http://www.w3.org/2000/svg">
                        <path fill-rule="evenodd" clip-rule="evenodd"
                          d="M6.25709 1.099C7.02209 -0.260998 8.97909 -0.260998 9.74309 1.099L15.3231 11.019C16.0731 12.353 15.1101 13.999 13.5811 13.999H2.42009C0.890093 13.999 -0.0729075 12.353 0.677092 11.019L6.25709 1.099ZM9.00009 11C9.00009 11.2652 8.89474 11.5196 8.7072 11.7071C8.51966 11.8946 8.26531 12 8.00009 12C7.73488 12 7.48052 11.8946 7.29299 11.7071C7.10545 11.5196 7.00009 11.2652 7.00009 11C7.00009 10.7348 7.10545 10.4804 7.29299 10.2929C7.48052 10.1054 7.73488 10 8.00009 10C8.26531 10 8.51966 10.1054 8.7072 10.2929C8.89474 10.4804 9.00009 10.7348 9.00009 11ZM8.00009 3C7.73488 3 7.48052 3.10536 7.29299 3.2929C7.10545 3.48043 7.00009 3.73479 7.00009 4V7C7.00009 7.26522 7.10545 7.51957 7.29299 7.70711C7.48052 7.89465 7.73488 8 8.00009 8C8.26531 8 8.51966 7.89465 8.7072 7.70711C8.89474 7.51957 9.00009 7.26522 9.00009 7V4C9.00009 3.73479 8.89474 3.48043 8.7072 3.2929C8.51966 3.10536 8.26531 3 8.00009 3Z"
                          fill="#E83C58" />
                      </svg>
                      <svg v-if="passowrd_errors.letter" width="26" height="27" viewBox="0 0 26 27" fill="none"
                        xmlns="http://www.w3.org/2000/svg">
                        <rect y="0.5" width="26" height="26" rx="13" fill="#34D399" />
                        <path d="M8.28986 14.1406L10.9814 16.7029L17.7101 10.2971" stroke="white" stroke-width="2"
                          stroke-linecap="round" stroke-linejoin="round" />
                      </svg>
                      {{ $t("other_woutlog.register_text_26") }}
                    </span>
                    <span :class="passowrd_errors.number ? 'active' : ''">
                      <svg v-if="!passowrd_errors.number" width="16" height="14" viewBox="0 0 16 14" fill="none"
                        xmlns="http://www.w3.org/2000/svg">
                        <path fill-rule="evenodd" clip-rule="evenodd"
                          d="M6.25709 1.099C7.02209 -0.260998 8.97909 -0.260998 9.74309 1.099L15.3231 11.019C16.0731 12.353 15.1101 13.999 13.5811 13.999H2.42009C0.890093 13.999 -0.0729075 12.353 0.677092 11.019L6.25709 1.099ZM9.00009 11C9.00009 11.2652 8.89474 11.5196 8.7072 11.7071C8.51966 11.8946 8.26531 12 8.00009 12C7.73488 12 7.48052 11.8946 7.29299 11.7071C7.10545 11.5196 7.00009 11.2652 7.00009 11C7.00009 10.7348 7.10545 10.4804 7.29299 10.2929C7.48052 10.1054 7.73488 10 8.00009 10C8.26531 10 8.51966 10.1054 8.7072 10.2929C8.89474 10.4804 9.00009 10.7348 9.00009 11ZM8.00009 3C7.73488 3 7.48052 3.10536 7.29299 3.2929C7.10545 3.48043 7.00009 3.73479 7.00009 4V7C7.00009 7.26522 7.10545 7.51957 7.29299 7.70711C7.48052 7.89465 7.73488 8 8.00009 8C8.26531 8 8.51966 7.89465 8.7072 7.70711C8.89474 7.51957 9.00009 7.26522 9.00009 7V4C9.00009 3.73479 8.89474 3.48043 8.7072 3.2929C8.51966 3.10536 8.26531 3 8.00009 3Z"
                          fill="#E83C58" />
                      </svg>
                      <svg v-if="passowrd_errors.number" width="26" height="27" viewBox="0 0 26 27" fill="none"
                        xmlns="http://www.w3.org/2000/svg">
                        <rect y="0.5" width="26" height="26" rx="13" fill="#34D399" />
                        <path d="M8.28986 14.1406L10.9814 16.7029L17.7101 10.2971" stroke="white" stroke-width="2"
                          stroke-linecap="round" stroke-linejoin="round" />
                      </svg>
                      {{ $t("other_woutlog.register_text_27") }}
                    </span>
                  </div>
                  <div v-if="errors.password" class="form-error registrationError">
                    <svg width="16" height="14" viewBox="0 0 16 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path fill-rule="evenodd" clip-rule="evenodd"
                        d="M6.25709 1.099C7.02209 -0.260998 8.97909 -0.260998 9.74309 1.099L15.3231 11.019C16.0731 12.353 15.1101 13.999 13.5811 13.999H2.42009C0.890093 13.999 -0.0729075 12.353 0.677092 11.019L6.25709 1.099ZM9.00009 11C9.00009 11.2652 8.89474 11.5196 8.7072 11.7071C8.51966 11.8946 8.26531 12 8.00009 12C7.73488 12 7.48052 11.8946 7.29299 11.7071C7.10545 11.5196 7.00009 11.2652 7.00009 11C7.00009 10.7348 7.10545 10.4804 7.29299 10.2929C7.48052 10.1054 7.73488 10 8.00009 10C8.26531 10 8.51966 10.1054 8.7072 10.2929C8.89474 10.4804 9.00009 10.7348 9.00009 11ZM8.00009 3C7.73488 3 7.48052 3.10536 7.29299 3.2929C7.10545 3.48043 7.00009 3.73479 7.00009 4V7C7.00009 7.26522 7.10545 7.51957 7.29299 7.70711C7.48052 7.89465 7.73488 8 8.00009 8C8.26531 8 8.51966 7.89465 8.7072 7.70711C8.89474 7.51957 9.00009 7.26522 9.00009 7V4C9.00009 3.73479 8.89474 3.48043 8.7072 3.2929C8.51966 3.10536 8.26531 3 8.00009 3Z"
                        fill="#E83C58" />
                    </svg>
                    {{ errors.password }}
                  </div>
                </div>
                <div class="flex items-start gap-3px">
                  <div class="checkbox-wrapper-28 mt-2px">
                    <input id="tmp-28" type="checkbox" class="promoted-input-checkbox" v-model="user.suhlas"/>
                    <label for="tmp-28"></label>
                    <svg><use xlink:href="#checkmark-28" /></svg>
                    <svg xmlns="http://www.w3.org/2000/svg" style="display: none">
                      <symbol id="checkmark-28" viewBox="0 0 24 24">
                        <path stroke-linecap="round" stroke-miterlimit="10" fill="none"  d="M22.9 3.7l-15.2 16.6-6.6-7.1">
                        </path>
                      </symbol>
                    </svg>
                  </div>
                  <div class="text-[#0F0F10] text-12px font-400 cursor-pointer"  @click="user.suhlas = !user.suhlas">
                    Prečítal/a som si <a href="https://www.doffero.com/DOFFERO_VOP_01_05_2025_l.pdf" target="_blank" class="text-[#0F0F10] underline" style="color: #0F0F10;" @click.stop>všeobecné obchodné podmienky</a> a súhlasím s nimi
                  </div>
                </div>
                <div v-if="errors.suhlas" class="form-error registrationError">
                  <svg width="16" height="14" viewBox="0 0 16 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path fill-rule="evenodd" clip-rule="evenodd"
                      d="M6.25709 1.099C7.02209 -0.260998 8.97909 -0.260998 9.74309 1.099L15.3231 11.019C16.0731 12.353 15.1101 13.999 13.5811 13.999H2.42009C0.890093 13.999 -0.0729075 12.353 0.677092 11.019L6.25709 1.099ZM9.00009 11C9.00009 11.2652 8.89474 11.5196 8.7072 11.7071C8.51966 11.8946 8.26531 12 8.00009 12C7.73488 12 7.48052 11.8946 7.29299 11.7071C7.10545 11.5196 7.00009 11.2652 7.00009 11C7.00009 10.7348 7.10545 10.4804 7.29299 10.2929C7.48052 10.1054 7.73488 10 8.00009 10C8.26531 10 8.51966 10.1054 8.7072 10.2929C8.89474 10.4804 9.00009 10.7348 9.00009 11ZM8.00009 3C7.73488 3 7.48052 3.10536 7.29299 3.2929C7.10545 3.48043 7.00009 3.73479 7.00009 4V7C7.00009 7.26522 7.10545 7.51957 7.29299 7.70711C7.48052 7.89465 7.73488 8 8.00009 8C8.26531 8 8.51966 7.89465 8.7072 7.70711C8.89474 7.51957 9.00009 7.26522 9.00009 7V4C9.00009 3.73479 8.89474 3.48043 8.7072 3.2929C8.51966 3.10536 8.26531 3 8.00009 3Z"
                      fill="#E83C58" />
                  </svg>
                  {{ errors.suhlas }}
                </div>
                <div class="form-submit">
                  <button type="submit" class="btn--primary" style="color: white; position: relative"
                    @click="save($event)">
                    <span v-if="!loading">{{ /*$t("other_woutlog.register_text_28") */


                      }}Pokračovať</span>
                    <div v-if="loading" class="loading-indicator">
                      <div class="circle"></div>
                      <div class="circle"></div>
                      <div class="circle"></div>
                    </div>
                    <svg v-if="!loading" class="arrow-icon" width="24" height="24" viewBox="0 0 24 24" fill="none"
                      xmlns="http://www.w3.org/2000/svg">
                      <path d="M7 7H17M17 7V17M17 7L7 17" stroke="white" stroke-width="2" stroke-linecap="round"
                        stroke-linejoin="round" />
                    </svg>
                  </button>
                </div>
                <div class="form-helper">
                  <p>
                    {{ /* $t("other_woutlog.register_text_29") */ }}
                    Pokračovaním v registrácií súhlasím s<br />
                    <a target="_blank" href="https://www.doffero.com/DOFFERO_zmluva_registracia.pdf">
                      {{ /*$t("other_woutlog.register_text_30") */ }}
                      Podmienkami spracovania osobných údajov</a>
                  </p>
                </div>
              </form>
            </div>
          </aside>

          <main class="registration__main">
            <div class="registration__main-box">
              <img class="doffero-screenshot" src="/img/auth/register/onboarding/doffero-screenshot.png"
                alt="Doffero" />
              <div class="users-bar">
                <div class="bar-images">
                  <img src="/img/auth/register/onboarding/user-01.png" alt="Doffero" />
                  <img src="/img/auth/register/onboarding/user-02.png" alt="Doffero" />
                  <img src="/img/auth/register/onboarding/user-03.png" alt="Doffero" />
                  <img src="/img/auth/register/onboarding/user-04.png" alt="Doffero" />
                </div>
                <div class="bar-text">
                  DOFFERO dôveruje už viac ako
                  {{ users_count }}+ používateľov
                </div>
              </div>
            </div>
          </main>
        </div>
      </div>

      <!-- TODO: step1 -->
      <div v-if="current_step == 1" class="step step-01">
        <header class="registration__head">
          <div class="main-header__logo">
            <a href="/"><img src="/img/welcome/logos/doffero-logo-v2.svg" alt="Doffero" /></a>
          </div>

          <div class="step-status">
            <div class="step-status__text">
              <span>Krok <span class="current-step">{{ 1 }}</span><span class="total">/5</span></span>
            </div>
            <div class="step-status__points">
              <span class="step-p-01 active"></span>
              <span class="step-p-02"></span>
              <span class="step-p-03"></span>
              <span class="step-p-04"></span>
              <span class="step-p-05"></span>
            </div>
          </div>
        </header>

        <div class="registration__content">
          <aside class="registration__side">
            <div class="side-top">
              <h1 class="main-title">
                {{ /*$t("other_woutlog.register_text_19") */ }}
                Ahoj{{ user.meno ? ", " + user.meno : "" }}. Podnikáš?
              </h1>
              <p class="main-subtext">
                {{ /*$t("other_woutlog.register_text_20") */ }}
                Pomôž nám spoznať ťa lepšie. My ti na oplátku presne
                prispôsobíme DOFFERO.
              </p>

              <div class="user-types-select">
                <div :class="userType == 1
                  ? 'user-type-select__box is-active'
                  : 'user-type-select__box'
                  " @click="userType = 1">
                  <div class="box-icon-holder">
                    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path
                        d="M21.09 6.98C20.24 6.04 18.82 5.57 16.76 5.57H16.52V5.53C16.52 3.85 16.52 1.77 12.76 1.77H11.24C7.48004 1.77 7.48004 3.86 7.48004 5.53V5.58H7.24004C5.17004 5.58 3.76004 6.05 2.91004 6.99C1.92004 8.09 1.95004 9.57 2.05004 10.58L2.06004 10.65L2.16004 11.7C2.17004 11.71 2.19004 11.73 2.21004 11.74C2.54004 11.96 2.88004 12.18 3.24004 12.38C3.38004 12.47 3.53004 12.55 3.68004 12.63C5.39004 13.57 7.27004 14.2 9.18004 14.51C9.27004 15.45 9.68004 16.55 11.87 16.55C14.06 16.55 14.49 15.46 14.56 14.49C16.6 14.16 18.57 13.45 20.35 12.41C20.41 12.38 20.45 12.35 20.5 12.32C20.96 12.06 21.39 11.78 21.81 11.47C21.83 11.46 21.85 11.44 21.86 11.42L21.9 11.06L21.95 10.59C21.96 10.53 21.96 10.48 21.97 10.41C22.05 9.4 22.03 8.02 21.09 6.98ZM13.09 13.83C13.09 14.89 13.09 15.05 11.86 15.05C10.63 15.05 10.63 14.86 10.63 13.84V12.58H13.09V13.83ZM8.91004 5.57V5.53C8.91004 3.83 8.91004 3.2 11.24 3.2H12.76C15.09 3.2 15.09 3.84 15.09 5.53V5.58H8.91004V5.57Z"
                        fill="#F93C34" />
                      <path opacity="0.4"
                        d="M20.5002 12.3C20.4502 12.33 20.4002 12.36 20.3502 12.39C18.5702 13.43 16.6002 14.13 14.5602 14.47C14.4802 15.43 14.0602 16.53 11.8702 16.53C9.68016 16.53 9.26016 15.44 9.18016 14.49C7.27016 14.19 5.39016 13.56 3.68016 12.61C3.53016 12.53 3.38016 12.45 3.24016 12.36C2.88016 12.16 2.54016 11.94 2.21016 11.72C2.19016 11.71 2.17016 11.69 2.16016 11.68L2.77016 18.19C2.98016 20.18 3.80016 22.23 8.20016 22.23H15.8202C20.2202 22.23 21.0402 20.18 21.2502 18.18L21.8802 11.4C21.8702 11.42 21.8502 11.44 21.8302 11.45C21.4002 11.76 20.9602 12.05 20.5002 12.3Z"
                        fill="#F93C34" />
                    </svg>
                  </div>
                  <div class="box-data">
                    <div class="data-title">Som podnikateľ</div>
                    <div class="data-description">
                      Som živnostník alebo vlastním s.r.o.čku
                    </div>
                  </div>
                </div>
                <div :class="userType == 2
                  ? 'user-type-select__box is-active'
                  : 'user-type-select__box'
                  " @click="userType = 2">
                  <div class="box-icon-holder">
                    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path
                        d="M21.8098 3.94C20.4998 7.21 17.5098 11.48 14.6598 14.27C14.2498 11.69 12.1898 9.67 9.58984 9.31C12.3898 6.45 16.6898 3.42 19.9698 2.1C20.5498 1.88 21.1298 2.05 21.4898 2.41C21.8698 2.79 22.0498 3.36 21.8098 3.94Z"
                        fill="#F93C34" />
                      <path opacity="0.4"
                        d="M14.6595 14.27C14.1595 14.76 13.6595 15.21 13.1795 15.59L11.2095 17.17C10.9595 17.35 10.7095 17.5 10.4295 17.62C10.4295 17.43 10.4095 17.24 10.3895 17.04C10.2795 16.21 9.89953 15.42 9.22953 14.75C8.53953 14.07 7.71953 13.68 6.86953 13.57C6.66953 13.55 6.45953 13.54 6.26953 13.55C6.37953 13.24 6.54953 12.95 6.75953 12.71L8.31953 10.74C8.68953 10.27 9.11953 9.79 9.58953 9.31C12.1895 9.67 14.2495 11.69 14.6595 14.27Z"
                        fill="#F93C34" />
                      <path
                        d="M10.4298 17.62C10.4298 18.72 10.0098 19.77 9.20976 20.56C8.59976 21.18 7.77977 21.6 6.77977 21.72L4.32976 21.99C2.98976 22.14 1.83976 20.99 1.98976 19.64L2.25976 17.18C2.49976 14.99 4.32976 13.59 6.26976 13.55C6.45976 13.54 6.66976 13.55 6.86976 13.57C7.71976 13.68 8.53976 14.07 9.22976 14.75C9.89976 15.42 10.2798 16.21 10.3898 17.04C10.4098 17.24 10.4298 17.43 10.4298 17.62Z"
                        fill="#F93C34" />
                    </svg>
                  </div>
                  <div class="box-data">
                    <div class="data-title">Niesom podnikateľ</div>
                    <div class="data-description">Momentálne nepodnikám</div>
                  </div>
                </div>
              </div>

              <div>
                <a class="btn--primary" style="color: white; position: relative" @click="save($event)">
                  <span v-if="!loading">{{ /*$t("other_woutlog.register_text_28") */


                    }}Pokračovať</span>
                  <div v-if="loading" class="loading-indicator">
                    <div class="circle"></div>
                    <div class="circle"></div>
                    <div class="circle"></div>
                  </div>
                  <svg v-if="!loading" class="arrow-icon" width="24" height="24" viewBox="0 0 24 24" fill="none"
                    xmlns="http://www.w3.org/2000/svg">
                    <path d="M7 7H17M17 7V17M17 7L7 17" stroke="white" stroke-width="2" stroke-linecap="round"
                      stroke-linejoin="round" />
                  </svg>
                </a>
              </div>
            </div>
          </aside>

          <main class="registration__main">
            <div class="registration__main-box">
              <img :class="userType == 1 ? 'group group-01 is-active' : 'group group-01 '
                " src="/img/auth/register/onboarding/podnikatel.png" alt="Doffero" />
              <img :class="userType == 2 ? 'group group-02 is-active' : 'group group-02'
                " src="/img/auth/register/onboarding/group-people-02.png" alt="Doffero" />
            </div>
          </main>
        </div>
      </div>

      <!-- TODO: step2 -->
      <div v-if="current_step == 2" class="step step-02">
        <header class="registration__head">
          <div class="main-header__logo">
            <a href="/"><img src="/img/welcome/logos/doffero-logo-v2.svg" alt="Doffero" /></a>
          </div>

          <div class="step-status">
            <div class="step-status__text">
              <span>Krok <span class="current-step">2</span><span class="total">/5</span></span>
            </div>
            <div class="step-status__points">
              <span class="step-p-01 past"></span>
              <span class="step-p-02 active"></span>
              <span class="step-p-03"></span>
              <span class="step-p-04"></span>
              <span class="step-p-05"></span>
            </div>
          </div>
        </header>

        <div class="registration__content">
          <aside class="registration__side">
            <div class="side-top">
              <h1 class="main-title">
                {{ /*$t("other_woutlog.register_text_19") */ }}
                {{
                  userType == 1
                    ? "Ako sa volá tvoja spoločnosť?"
                    : "Ako sa volá tvoja značka či projekt?"
                }}
              </h1>
              <p class="main-subtext">
                {{ /*$t("other_woutlog.register_text_20") */ }}
                {{
                  userType == 1
                    ? "Na základe jej názvu sa pokúsime nájsť údaje o spoločnosti, aby sme ti uľahčili vypisovanie."
                    : "Na základe názvu tvojej značky ti pripravíme profil v DOFFERO."
                }}
              </p>

              <form class="form" action=".">
                <div class="form-group">
                  <div class="form-row">
                    <label class="form__label" for="companyName">
                      {{
                        userType == 1
                          ? "Názov spoločnosti"
                          : "Názov značky alebo projektu"
                      }}</label>
                    <div v-if="userType == 1">
                      <a href="#" class="link--bordered" @click="showExtendedFields = !showExtendedFields">
                        <span v-if="showExtendedFields == false">Viac údajov o firme</span>
                        <span v-if="showExtendedFields == true">Menej údajov o firme</span>
                      </a>
                    </div>
                  </div>

                  <input class="form__input" type="text" name="companyName"
                    :id="userType == 1 ? 'companyName' : 'brandName'" v-model="companyDatas.name" />
                  <div v-if="errors.company_name" class="form-error registrationError">
                    <svg width="16" height="14" viewBox="0 0 16 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path fill-rule="evenodd" clip-rule="evenodd"
                        d="M6.25709 1.099C7.02209 -0.260998 8.97909 -0.260998 9.74309 1.099L15.3231 11.019C16.0731 12.353 15.1101 13.999 13.5811 13.999H2.42009C0.890093 13.999 -0.0729075 12.353 0.677092 11.019L6.25709 1.099ZM9.00009 11C9.00009 11.2652 8.89474 11.5196 8.7072 11.7071C8.51966 11.8946 8.26531 12 8.00009 12C7.73488 12 7.48052 11.8946 7.29299 11.7071C7.10545 11.5196 7.00009 11.2652 7.00009 11C7.00009 10.7348 7.10545 10.4804 7.29299 10.2929C7.48052 10.1054 7.73488 10 8.00009 10C8.26531 10 8.51966 10.1054 8.7072 10.2929C8.89474 10.4804 9.00009 10.7348 9.00009 11ZM8.00009 3C7.73488 3 7.48052 3.10536 7.29299 3.2929C7.10545 3.48043 7.00009 3.73479 7.00009 4V7C7.00009 7.26522 7.10545 7.51957 7.29299 7.70711C7.48052 7.89465 7.73488 8 8.00009 8C8.26531 8 8.51966 7.89465 8.7072 7.70711C8.89474 7.51957 9.00009 7.26522 9.00009 7V4C9.00009 3.73479 8.89474 3.48043 8.7072 3.2929C8.51966 3.10536 8.26531 3 8.00009 3Z"
                        fill="#E83C58" />
                    </svg>
                    {{ errors.company_name }}
                  </div>
                </div>

                <div class="form-extended-fields" v-show="showExtendedFields">
                  <div class="form-group">
                    <div class="form-row form-row--hasgap">
                      <div class="form-item">
                        <label class="form__label" for="companyIco">IČO</label>
                        <input class="form__input" type="text" name="companyIco" id="companyIco"
                          v-model="companyDatas.ico" />
                      </div>
                      <div class="form-item">
                        <label class="form__label" for="companyDic">DIČ</label>
                        <input class="form__input" type="text" name="companyDic" id="companyDic"
                          v-model="companyDatas.dic" />
                      </div>
                    </div>
                  </div>
                  <div class="form-group">
                    <label class="form__label" for="companyDph">IČ DPH</label>
                    <input class="form__input" type="text" name="companyDph" id="companyDph"
                      v-model="companyDatas.dph" />
                  </div>
                  <div class="form-group">
                    <label class="form__label" for="companyStreet">Ulica a číslo sídla firmy</label>
                    <input class="form__input" type="text" name="companyStreet" id="companyStreet"
                      v-model="companyDatas.address.street" />
                  </div>
                  <div class="form-group">
                    <div class="form-row form-row--hasgap">
                      <div class="form-item">
                        <label class="form__label" for="companyZip">PSČ sídla firmy</label>
                        <input class="form__input" type="text" name="companyZip" id="companyZip"
                          v-model="companyDatas.address.zipCode" />
                      </div>
                      <div class="form-item">
                        <label class="form__label" for="companyCity">Mesto sídla firmy</label>
                        <input class="form__input" type="text" name="companyCity" id="companyCity"
                          v-model="companyDatas.address.city" />
                      </div>
                    </div>
                  </div>
                </div>
                <!-- ./ form-extended-fields */ -->
                <div v-show="userType == 1" class="form-row">
                  <div class="checkbox-wrapper">
                    <label for="dphCheck">
                      <input type="checkbox" id="dphCheck" v-model="dphCheck" />
                      Som platca DPH
                    </label>
                  </div>
                  <div class="additional-text" v-if="dphCheck">
                    Navýšiť ceny s
                    <span class="additional-text__value"><input type="text" id="vatInput"
                        v-model="companyDatas.vatField" />%</span>
                    DPH
                  </div>
                </div>
              </form>

              <div class="side-actions">
                <a href="#" class="link--back" @click="() => {
                  current_step--;
                }
                ">Krok späť</a>
                <a class="btn--primary" style="color: white; position: relative; width: 250px" @click="save($event)">
                  <span v-if="!loading">{{ /*$t("other_woutlog.register_text_28") */


                    }}Pokračovať</span>
                  <div v-if="loading" class="loading-indicator">
                    <div class="circle"></div>
                    <div class="circle"></div>
                    <div class="circle"></div>
                  </div>
                  <svg v-if="!loading" class="arrow-icon" width="24" height="24" viewBox="0 0 24 24" fill="none"
                    xmlns="http://www.w3.org/2000/svg">
                    <path d="M7 7H17M17 7V17M17 7L7 17" stroke="white" stroke-width="2" stroke-linecap="round"
                      stroke-linejoin="round" />
                  </svg>
                </a>
              </div>
            </div>
          </aside>

          <main class="registration__main">
            <div v-if="userType == 1" class="registration__main-box">
              <div class="company-card">
                <div class="company-card__badge approved" v-if="
                  companyDatas.dph &&
                  companyDatas.ico &&
                  companyDatas.dic &&
                  companyDatas.address.zipCode &&
                  companyDatas.address.city &&
                  companyDatas.address.street &&
                  companyDatas.name
                ">
                  <svg width="12" height="12" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <g clip-path="url(#a)">
                      <path
                        d="M6 0C2.7 0 0 2.7 0 6s2.7 6 6 6 6-2.7 6-6-2.7-6-6-6Zm2.78 5.03-3 3a.748.748 0 0 1-1.06 0l-1.5-1.5a.75.75 0 1 1 1.06-1.06l.97.97 2.47-2.47a.75.75 0 1 1 1.06 1.06Z"
                        fill="#18343A" />
                    </g>
                    <defs>
                      <clipPath id="a">
                        <path fill="#fff" d="M0 0h12v12H0z" />
                      </clipPath>
                    </defs>
                  </svg>
                  Overené
                </div>
                <div class="company-card__title">
                  {{
                    companyDatas.name ? companyDatas.name : "Názov spoločnosti"
                  }}
                </div>
                <div class="company-card__address">
                  <div>
                    {{
                      companyDatas.address.street
                        ? companyDatas.address.street
                        : "Adresa"
                    }}
                  </div>
                  <div v-if="
                    companyDatas.address.zipCode || companyDatas.address.city
                  ">
                    {{
                      companyDatas.address.zipCode +
                      " " +
                      companyDatas.address.city
                    }}
                  </div>
                  <div v-else>spoločnosti</div>
                </div>
                <div class="company-card__items">
                  <div class="company-card__data">
                    <div class="data-item">
                      <div class="item-label">IČO:</div>
                      <div class="item-value">
                        {{ companyDatas.ico }}
                      </div>
                    </div>
                    <div class="data-item">
                      <div class="item-label">DIČ:</div>
                      <div class="item-value">
                        {{ companyDatas.dic }}
                      </div>
                    </div>
                    <div class="data-item">
                      <div class="item-label">IČ DPH:</div>
                      <div class="item-value">
                        {{ companyDatas.dph }}
                      </div>
                    </div>
                  </div>
                  <div class="company-card__logo">
                    <!-- TODO: here is the placeholder for company's logo -->
                    <img src="/img/welcome/logos/doffero-logo-v2.svg" alt="." />
                  </div>
                </div>
              </div>
            </div>
            <div v-if="userType == 2" class="registration__main-box">
              <img class="group group-02 is-active" src="/img/auth/register/onboarding/group-people-01.png"
                alt="Doffero" />
            </div>
          </main>

          <!-- Mobile version of actions -->
          <div class="side-actions side-actions--isMobile">
            <a href="#" class="link--back" @click="() => {
              current_step--;
            }
            ">Krok späť</a>
            <a class="btn--primary" style="color: white; position: relative; width: 250px" @click="save($event)">
              <span v-if="!loading">{{ /*$t("other_woutlog.register_text_28") */

                }}Pokračovať</span>
              <div v-if="loading" class="loading-indicator">
                <div class="circle"></div>
                <div class="circle"></div>
                <div class="circle"></div>
              </div>
              <svg v-if="!loading" class="arrow-icon" width="24" height="24" viewBox="0 0 24 24" fill="none"
                xmlns="http://www.w3.org/2000/svg">
                <path d="M7 7H17M17 7V17M17 7L7 17" stroke="white" stroke-width="2" stroke-linecap="round"
                  stroke-linejoin="round" />
              </svg>
            </a>
          </div>
        </div>
      </div>

      <!-- TODO: step3 -->
      <div v-if="current_step == 3" class="step step-03">
        <header class="registration__head">
          <div class="main-header__logo">
            <a href="/"><img src="/img/welcome/logos/doffero-logo-v2.svg" alt="Doffero" /></a>
          </div>

          <div class="step-status">
            <div class="step-status__text">
              <span>Krok <span class="current-step">3</span><span class="total">/5</span></span>
            </div>
            <div class="step-status__points">
              <span class="step-p-01 past"></span>
              <span class="step-p-02 past"></span>
              <span class="step-p-03 active"></span>
              <span class="step-p-04"></span>
              <span class="step-p-05"></span>
            </div>
          </div>
        </header>

        <div class="registration__content">
          <aside class="registration__side">
            <div class="side-top">
              <h1 class="main-title">
                {{ /*$t("other_woutlog.register_text_19") */ }}
                {{
                  userType == 1
                    ? "Prispôsob si DOFFERO \n presne pre svoju firmu"
                    : "Prispôsob si DOFFERO \n presne pre svoju značku"
                }}
              </h1>
              <p class="main-subtext">
                {{ /*$t("other_woutlog.register_text_20") */ }}
                Vďaka týmto informáciám získaš <br />
                s cenovými ponukami profesionálne výsledky.
              </p>

              <form class="form" action=".">
                <div class="form-group">
                  <label class="form__label" for="businessType">
                    {{
                      userType == 1 ? "Typ podnikania" : "Oblasť tvojej značky"
                    }}</label>
                  <v-select v-model="selectedBusiness" :items="businessTypes" label="Vyberte" item-text="name"
                    item-value="id" solo multiple hide-details @change="selectBusiness($event)" append-icon="fas fa-chevron-down"></v-select>
                </div>
                <div v-if="errors.selectedBusiness" class="form-error registrationError" style="margin-bottom: 20px">
                  <svg width="16" height="14" viewBox="0 0 16 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path fill-rule="evenodd" clip-rule="evenodd"
                      d="M6.25709 1.099C7.02209 -0.260998 8.97909 -0.260998 9.74309 1.099L15.3231 11.019C16.0731 12.353 15.1101 13.999 13.5811 13.999H2.42009C0.890093 13.999 -0.0729075 12.353 0.677092 11.019L6.25709 1.099ZM9.00009 11C9.00009 11.2652 8.89474 11.5196 8.7072 11.7071C8.51966 11.8946 8.26531 12 8.00009 12C7.73488 12 7.48052 11.8946 7.29299 11.7071C7.10545 11.5196 7.00009 11.2652 7.00009 11C7.00009 10.7348 7.10545 10.4804 7.29299 10.2929C7.48052 10.1054 7.73488 10 8.00009 10C8.26531 10 8.51966 10.1054 8.7072 10.2929C8.89474 10.4804 9.00009 10.7348 9.00009 11ZM8.00009 3C7.73488 3 7.48052 3.10536 7.29299 3.2929C7.10545 3.48043 7.00009 3.73479 7.00009 4V7C7.00009 7.26522 7.10545 7.51957 7.29299 7.70711C7.48052 7.89465 7.73488 8 8.00009 8C8.26531 8 8.51966 7.89465 8.7072 7.70711C8.89474 7.51957 9.00009 7.26522 9.00009 7V4C9.00009 3.73479 8.89474 3.48043 8.7072 3.2929C8.51966 3.10536 8.26531 3 8.00009 3Z"
                      fill="#E83C58" />
                  </svg>
                  {{ errors.selectedBusiness }}
                </div>
                <div class="form-group" v-if="showOtherInput">
                  <label class="form__label" for="otherBusiness">Vieš konkretizovať?</label>
                  <input class="form__input" type="text" name="otherBusiness" id="otherBusiness"
                    v-model="otherBusinessField" />
                </div>
                <div v-if="errors.otherBusinessField" class="form-error registrationError" style="margin-bottom: 20px">
                  <svg width="16" height="14" viewBox="0 0 16 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path fill-rule="evenodd" clip-rule="evenodd"
                      d="M6.25709 1.099C7.02209 -0.260998 8.97909 -0.260998 9.74309 1.099L15.3231 11.019C16.0731 12.353 15.1101 13.999 13.5811 13.999H2.42009C0.890093 13.999 -0.0729075 12.353 0.677092 11.019L6.25709 1.099ZM9.00009 11C9.00009 11.2652 8.89474 11.5196 8.7072 11.7071C8.51966 11.8946 8.26531 12 8.00009 12C7.73488 12 7.48052 11.8946 7.29299 11.7071C7.10545 11.5196 7.00009 11.2652 7.00009 11C7.00009 10.7348 7.10545 10.4804 7.29299 10.2929C7.48052 10.1054 7.73488 10 8.00009 10C8.26531 10 8.51966 10.1054 8.7072 10.2929C8.89474 10.4804 9.00009 10.7348 9.00009 11ZM8.00009 3C7.73488 3 7.48052 3.10536 7.29299 3.2929C7.10545 3.48043 7.00009 3.73479 7.00009 4V7C7.00009 7.26522 7.10545 7.51957 7.29299 7.70711C7.48052 7.89465 7.73488 8 8.00009 8C8.26531 8 8.51966 7.89465 8.7072 7.70711C8.89474 7.51957 9.00009 7.26522 9.00009 7V4C9.00009 3.73479 8.89474 3.48043 8.7072 3.2929C8.51966 3.10536 8.26531 3 8.00009 3Z"
                      fill="#E83C58" />
                  </svg>
                  {{ errors.otherBusinessField }}
                </div>
                <div class="form-group">
                  <label class="form__label" for="employeesNumber">{{
                    userType == 1 ? "Veľkosť firmy" : "Koľko vás je?"
                  }}</label>
                  <v-select v-model="selectedEmployee" :items="employeeItems" item-text="name" item-value="id"
                    label="Vyberte" solo hide-details @change="selectEmployee($event)" append-icon="fas fa-chevron-down"></v-select>
                </div>
                <div v-if="errors.selectedEmployee" class="form-error registrationError">
                  <svg width="16" height="14" viewBox="0 0 16 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path fill-rule="evenodd" clip-rule="evenodd"
                      d="M6.25709 1.099C7.02209 -0.260998 8.97909 -0.260998 9.74309 1.099L15.3231 11.019C16.0731 12.353 15.1101 13.999 13.5811 13.999H2.42009C0.890093 13.999 -0.0729075 12.353 0.677092 11.019L6.25709 1.099ZM9.00009 11C9.00009 11.2652 8.89474 11.5196 8.7072 11.7071C8.51966 11.8946 8.26531 12 8.00009 12C7.73488 12 7.48052 11.8946 7.29299 11.7071C7.10545 11.5196 7.00009 11.2652 7.00009 11C7.00009 10.7348 7.10545 10.4804 7.29299 10.2929C7.48052 10.1054 7.73488 10 8.00009 10C8.26531 10 8.51966 10.1054 8.7072 10.2929C8.89474 10.4804 9.00009 10.7348 9.00009 11ZM8.00009 3C7.73488 3 7.48052 3.10536 7.29299 3.2929C7.10545 3.48043 7.00009 3.73479 7.00009 4V7C7.00009 7.26522 7.10545 7.51957 7.29299 7.70711C7.48052 7.89465 7.73488 8 8.00009 8C8.26531 8 8.51966 7.89465 8.7072 7.70711C8.89474 7.51957 9.00009 7.26522 9.00009 7V4C9.00009 3.73479 8.89474 3.48043 8.7072 3.2929C8.51966 3.10536 8.26531 3 8.00009 3Z"
                      fill="#E83C58" />
                  </svg>
                  {{ errors.selectedEmployee }}
                </div>
              </form>

              <div class="side-actions">
                <a href="#" class="link--back" @click="() => {
                  current_step--;
                }
                ">Krok späť</a>
                <a class="btn--primary" style="color: white; position: relative; width: 250px" @click="save($event)">
                  <span v-if="!loading">{{ /*$t("other_woutlog.register_text_28") */


                    }}Pokračovať</span>
                  <div v-if="loading" class="loading-indicator">
                    <div class="circle"></div>
                    <div class="circle"></div>
                    <div class="circle"></div>
                  </div>
                  <svg v-if="!loading" class="arrow-icon" width="24" height="24" viewBox="0 0 24 24" fill="none"
                    xmlns="http://www.w3.org/2000/svg">
                    <path d="M7 7H17M17 7V17M17 7L7 17" stroke="white" stroke-width="2" stroke-linecap="round"
                      stroke-linejoin="round" />
                  </svg>
                </a>
              </div>
            </div>
          </aside>

          <main class="registration__main">
            <div class="registration__main-box">
              <!-- TODO: More images -->
              <img src="/img/auth/register/onboarding/dogs1.png" alt="." v-if="employeeItemNumber == null" />
              <img src="/img/auth/register/onboarding/dogs1.png" alt="." v-if="employeeItemNumber == 0" />
              <img src="/img/auth/register/onboarding/dogs1.png" alt="." v-if="employeeItemNumber == 1" />
              <img src="/img/auth/register/onboarding/dogs2.png" alt="." v-if="employeeItemNumber == 2" />
              <img src="/img/auth/register/onboarding/dogs3.png" alt="." v-if="employeeItemNumber == 3" />
              <img src="/img/auth/register/onboarding/dogs4.png" alt="." v-if="employeeItemNumber == 4" />
              <img src="/img/auth/register/onboarding/dogs5.png" alt="." v-if="employeeItemNumber == 5" />
            </div>
          </main>

          <div class="side-actions side-actions--isMobile">
            <a href="#" class="link--back" @click="() => {
              current_step--;
            }
            ">Krok späť</a>
            <a class="btn--primary" style="color: white; position: relative; width: 250px" @click="save($event)">
              <span v-if="!loading">{{ /*$t("other_woutlog.register_text_28") */

                }}Pokračovať</span>
              <div v-if="loading" class="loading-indicator">
                <div class="circle"></div>
                <div class="circle"></div>
                <div class="circle"></div>
              </div>
              <svg v-if="!loading" class="arrow-icon" width="24" height="24" viewBox="0 0 24 24" fill="none"
                xmlns="http://www.w3.org/2000/svg">
                <path d="M7 7H17M17 7V17M17 7L7 17" stroke="white" stroke-width="2" stroke-linecap="round"
                  stroke-linejoin="round" />
              </svg>
            </a>
          </div>
        </div>
      </div>

      <div v-if="current_step == 4" class="step step-04">
        <header class="registration__head">
          <div class="main-header__logo">
            <a href="/"><img src="/img/welcome/logos/doffero-logo-v2.svg" alt="Doffero" /></a>
          </div>

          <div class="step-status">
            <div class="step-status__text">
              <span>Krok <span class="current-step">3</span><span class="total">/5</span></span>
            </div>
            <div class="step-status__points">
              <span class="step-p-01 past"></span>
              <span class="step-p-02 past"></span>
              <span class="step-p-03 past"></span>
              <span class="step-p-04 active"></span>
              <span class="step-p-05"></span>
            </div>
          </div>
        </header>

        <div class="registration__content">
          <aside class="registration__side">
            <div class="side-top">
              <h1 class="main-title">
                {{ /*$t("other_woutlog.register_text_19") */ }}
                Vylaď si vzhľad ponúk
              </h1>
              <p class="main-subtext">
                {{ /*$t("other_woutlog.register_text_20") */ }}

                {{
                  userType == 1
                    ? "Nastav si logo, URL a farbu, aby ešte lepšie predávali a reprezentovali tvoju firmu. Všetky nastavenia si môžeš neskôr upraviť."
                    : "Nastav si logo, URL a farbu, aby ešte lepšie predávali a reprezentovali tvoju značku. Všetky nastavenia si môžeš neskôr upraviť."
                }}
              </p>

              <form class="form" action=".">
                <div class="form-group">
                  <label class="form__label" for="companyName">Logo firmy
                    <span class="light-text">(Nepovinné)</span></label>
                  <div class="file-upload-box" @click="fileInputTrigger">
                    <input type="file" id="fileInput" style="display: none" @change="selectFileLogo($event)"
                      accept="image/*" />
                    <div class="file-upload-box__placeholder" v-show="!companyLogoImage">
                      vlož, alebo nahraj logo firmy
                    </div>
                    <div class="file-upload-box__logo-holder" v-show="companyLogoImage">
                      <img :src="companyLogoImage" alt="." />
                      <!-- TODO: tooltip component for delete button -->
                      <v-tooltip top allow-overflow>
                        <template v-slot:activator="{ on, attrs }">
                          <v-btn class="file-upload-box__delete" v-bind="attrs" v-on="on"
                            @click.stop="companyLogoImage = ''">
                            <svg width="12" height="12" fill="none" xmlns="http://www.w3.org/2000/svg">
                              <path
                                d="M10.535 2.615c-.805-.08-1.61-.14-2.42-.185v-.005l-.11-.65C7.93 1.315 7.82.625 6.65.625H5.34c-1.165 0-1.275.66-1.355 1.145l-.105.64c-.465.03-.93.06-1.395.105l-1.02.1a.376.376 0 0 0-.34.41c.02.205.2.355.41.335l1.02-.1c2.62-.26 5.26-.16 7.91.105h.04c.19 0 .355-.145.375-.34a.383.383 0 0 0-.345-.41ZM9.615 4.07a.632.632 0 0 0-.455-.195H2.84a.624.624 0 0 0-.625.665l.31 5.13c.055.76.125 1.71 1.87 1.71h3.21c1.745 0 1.815-.945 1.87-1.71l.31-5.125a.648.648 0 0 0-.17-.475Z"
                                fill="#F93C34" />
                            </svg>
                          </v-btn>
                        </template>
                        <span>Odstrániť</span>
                      </v-tooltip>
                    </div>
                  </div>
                </div>
                <div class="form-group">
                  <label class="form__label" for="companyUrl">Tvar URL</label>
                  <input class="form__input" type="text" name="companyUrl" id="companyUrl" v-model="companyUrl" />
                </div>
                <div v-if="errors.companyUrl" class="form-error registrationError" style="margin-bottom: 20px">
                  <svg width="16" height="14" viewBox="0 0 16 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path fill-rule="evenodd" clip-rule="evenodd"
                      d="M6.25709 1.099C7.02209 -0.260998 8.97909 -0.260998 9.74309 1.099L15.3231 11.019C16.0731 12.353 15.1101 13.999 13.5811 13.999H2.42009C0.890093 13.999 -0.0729075 12.353 0.677092 11.019L6.25709 1.099ZM9.00009 11C9.00009 11.2652 8.89474 11.5196 8.7072 11.7071C8.51966 11.8946 8.26531 12 8.00009 12C7.73488 12 7.48052 11.8946 7.29299 11.7071C7.10545 11.5196 7.00009 11.2652 7.00009 11C7.00009 10.7348 7.10545 10.4804 7.29299 10.2929C7.48052 10.1054 7.73488 10 8.00009 10C8.26531 10 8.51966 10.1054 8.7072 10.2929C8.89474 10.4804 9.00009 10.7348 9.00009 11ZM8.00009 3C7.73488 3 7.48052 3.10536 7.29299 3.2929C7.10545 3.48043 7.00009 3.73479 7.00009 4V7C7.00009 7.26522 7.10545 7.51957 7.29299 7.70711C7.48052 7.89465 7.73488 8 8.00009 8C8.26531 8 8.51966 7.89465 8.7072 7.70711C8.89474 7.51957 9.00009 7.26522 9.00009 7V4C9.00009 3.73479 8.89474 3.48043 8.7072 3.2929C8.51966 3.10536 8.26531 3 8.00009 3Z"
                      fill="#E83C58" />
                  </svg>
                  {{ errors.companyUrl }}
                </div>
                <div class="form-group">
                  <div class="form-row">
                    <label class="form__label" for="companyColor">Farba ponúk</label>
                    <div v-if="showColorInput == false">
                      <a href="#" class="link--bordered" @click.prevent="showColorInput = true">Vlastné farby</a>
                    </div>
                    <div v-if="showColorInput == true">
                      <a href="#" class="link--bordered" @click.prevent="showColorInput = false">Základné farby</a>
                    </div>
                  </div>
                  <div class="colors" v-show="showColorInput == false">
                    <div class="colors__item is-active" data-color="#CF5562" @click="changeColor($event, '#CF5562')">
                    </div>
                    <div class="colors__item" data-color="#DE6A43" @click="changeColor($event, '#DE6A43')"></div>
                    <div class="colors__item" data-color="#F6E3AA" @click="changeColor($event, '#F6E3AA')"></div>
                    <div class="colors__item" data-color="#90C273" @click="changeColor($event, '#90C273')"></div>
                    <div class="colors__item" data-color="#BCE3F0" @click="changeColor($event, '#BCE3F0')"></div>
                    <div class="colors__item" data-color="#4760B8" @click="changeColor($event, '#4760B8')"></div>
                    <div class="colors__item" data-color="#000000" @click="changeColor($event, '#000000')"></div>
                  </div>
                  <div class="colors-result input-wrapper" v-if="showColorInput">
                    <input class="form__input" type="text" name="companyColor" id="companyColor"
                      v-model="companyColor" />
                    <span class="active-color" :style="{
                      backgroundColor: companyColor,
                    }"></span>
                  </div>
                </div>
              </form>

              <div class="side-actions">
                <a href="#" class="link--back" @click="() => {
                  current_step--;
                }
                ">Krok späť</a>
                <a class="btn--primary" style="color: white; position: relative; width: 250px" @click="save($event)">
                  <span v-if="!loading">{{ /*$t("other_woutlog.register_text_28") */


                    }}Pokračovať</span>
                  <div v-if="loading" class="loading-indicator">
                    <div class="circle"></div>
                    <div class="circle"></div>
                    <div class="circle"></div>
                  </div>
                  <svg v-if="!loading" class="arrow-icon" width="24" height="24" viewBox="0 0 24 24" fill="none"
                    xmlns="http://www.w3.org/2000/svg">
                    <path d="M7 7H17M17 7V17M17 7L7 17" stroke="white" stroke-width="2" stroke-linecap="round"
                      stroke-linejoin="round" />
                  </svg>
                </a>
              </div>
            </div>
          </aside>

          <main class="registration__main">
            <div class="registration__main-box">
              <!-- TODO: More images -->
              <!-- <img
                class="doffero-price-quote"
                src="img/auth/register/onboarding/doffero-price-quote-screenshot.png"
                alt="."
              /> -->
              <!-- <div class="price-quote-overlay" @click="isShowedOverlay = false" v-show="isShowedOverlay">
                <div class="price-quote-overlay__text">Checking the preview</div>
                <svg width="800" height="800" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path d="m7 9.293 1.146-1.147a.5.5 0 1 1 .708.708l-2 2a.5.5 0 0 1-.708 0l-2-2a.5.5 0 1 1 .708-.708L6 9.293V2.5a.5.5 0 0 1 1 0v6.793Zm7 .207v2.547a1.415 1.415 0 0 1-2.32 1.087l-.924-.77A1.572 1.572 0 0 0 9.75 12a.693.693 0 0 0-.625.393l-.035.074a.797.797 0 0 0 .104.854l4.414 5.32A3.758 3.758 0 0 0 16.5 20a4.5 4.5 0 0 0 4.5-4.5v-4a.5.5 0 1 0-1 0v1a.5.5 0 1 1-1 0v-2a.5.5 0 1 0-1 0v2a.5.5 0 1 1-1 0v-3a.5.5 0 1 0-1 0v3a.5.5 0 1 1-1 0v-7a.5.5 0 1 0-1 0v4Zm-1 0v-4a1.5 1.5 0 0 1 3 0v2.585a1.5 1.5 0 0 1 1.947 1.02 1.5 1.5 0 0 1 2 1A1.5 1.5 0 0 1 22 11.5v4a5.5 5.5 0 0 1-5.5 5.5 4.758 4.758 0 0 1-3.662-1.72l-4.413-5.32a1.797 1.797 0 0 1-.236-1.927l.035-.074A1.693 1.693 0 0 1 9.75 11c.602 0 1.184.21 1.646.596l.924.77a.415.415 0 0 0 .68-.319V9.5Z"/></svg>
              </div> -->
              <div class="price-quote-view">
                <div class="price-quote-view__browser-bar"></div>
                <div class="price-quote-view__tool-bar">
                  <img src="img/auth/register/onboarding/actions.png" alt="" />
                  <div class="price-quote-view__address-bar">
                    <img src="img/auth/register/onboarding/secure-icon.svg" alt="" />
                    <div class="address-bar__value">
                      <span>www.doffero.com/ID_ponuky/</span>
                      <span class="slug">{{ companyUrl }}</span>
                    </div>
                  </div>
                </div>
                <div class="price-quote-view__main-view">
                  <div class="main-view__top">
                    <span></span>
                    <span></span>
                    <span></span>
                  </div>
                  <div class="main-view__content">
                    <div class="main-view__head">
                      <div class="main-view__logo">
                        <div v-if="companyLogoImage">
                          <img :src="companyLogoImage" alt="doffero" />
                        </div>
                      </div>
                    </div>
                    <div class="offer-box">
                      <div class="circle-graphics" :style="{
                        backgroundColor: companyColor,
                      }">
                        <span class="circle-graphics__outline"></span>
                      </div>
                      <div class="offer-box__title">Cenová ponuka</div>
                      <p class="offer-box__text">
                        Lorem ipsum dolor, sit amet consectetur adipisicing elit
                        ea molestias quia eligendi quidem aut totam?
                      </p>

                      <div class="offer-box__list">
                        <div class="list-box list-box--hover" :style="{
                          borderColor: companyColor,
                          color: companyColor,
                        }">
                          <div class="label" :style="{
                            color: companyColor,
                          }">
                            Projektové zadanie
                          </div>
                          <div class="value" :style="{
                            color: companyColor,
                          }">
                            2 000 &euro;
                          </div>
                        </div>
                        <div class="list-box">
                          <div class="label">Wireframes a dizajn</div>
                          <div class="value">2 400 &euro;</div>
                        </div>
                        <div class="list-box">
                          <div class="label">Projektovy manazment</div>
                          <div class="value">1 000 &euro;</div>
                        </div>
                        <div class="list-box list-box--total">
                          <div class="label">Celková cena</div>
                          <div class="value">7 000 &euro;</div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </main>

          <div class="side-actions side-actions--isMobile">
            <a href="#" class="link--back" @click="() => {
              current_step--;
            }
            ">Krok späť</a>
            <a class="btn--primary" style="color: white; position: relative; width: 250px" @click="save($event)">
              <span v-if="!loading">{{ /*$t("other_woutlog.register_text_28") */

                }}Pokračovať</span>
              <div v-if="loading" class="loading-indicator">
                <div class="circle"></div>
                <div class="circle"></div>
                <div class="circle"></div>
              </div>
              <svg v-if="!loading" class="arrow-icon" width="24" height="24" viewBox="0 0 24 24" fill="none"
                xmlns="http://www.w3.org/2000/svg">
                <path d="M7 7H17M17 7V17M17 7L7 17" stroke="white" stroke-width="2" stroke-linecap="round"
                  stroke-linejoin="round" />
              </svg>
            </a>
          </div>
        </div>
      </div>



      <!-- TODO: Step 5 cennik -->
      <div v-if="current_step == 5" class="step start-step">
        <header class="registration__head">
          <div class="main-header__logo">
            <a href="/"><img src="/img/welcome/logos/doffero-logo-v2.svg" alt="Doffero" /></a>
          </div>

          <div class="step-status">
            <div class="step-status__text">
              <span>Krok <span class="current-step">{{ 5 }}</span><span class="total">/5</span></span>
            </div>
            <div class="step-status__points">
              <span class="step-p-01 past"></span>
              <span class="step-p-02 past"></span>
              <span class="step-p-03 past"></span>
              <span class="step-p-04 past"></span>
              <span class="step-p-05 active"></span>
            </div>
          </div>
        </header>
        <div class="main-width mx-auto d-flex flex-col gap-18px justify-center items-center mt-50px">
          <h1 class="main-title text-32px font-500 text-center">
            Vyber si svoj balík
          </h1>
          <p class="main-subtext text-center">
            Vyber si balík, ktorý tvojmu podnikaniu a procesom vyhovuje najviac. 
          </p>
          <stripe-price-plan 
          location="auth" 
          :user_id="user.id" 
          :is_logged_in="1" 
          @free-plan-selected="freePlanSelected" 
          :user_invoice_details="remapCompanyDatasToInvoiceDetails()"
          />
          <div class="flex justify-center items-center gap-70px">
            <a href="#" class="link--back text-16px font-500 " @click="() => {
              current_step--;
            }
            ">Krok späť</a>
          </div>
        </div>

      </div>

      <!-- TODO: Step processing view -->
      <div v-if="current_step == 6" class="step step-process">
        <div class="process-content">
          <div class="process-content__graphics">
            <svg xmlns="http://www.w3.org/2000/svg" width="58" height="60" viewBox="0 0 58 60" fill="none">
              <path
                d="M57.9572 21.7143C57.9406 15.9493 55.645 10.4262 51.5734 6.35575C47.5018 2.28529 41.9865 -0.000327934 36.2368 3.5291e-08H7.97532C5.96894 0.102675 4.06566 0.922618 2.61034 2.31124C1.15505 3.69986 0.244045 5.56527 0.0424387 7.5694C-0.159169 9.57354 0.361959 11.5838 1.51138 13.2358C2.6608 14.8879 4.36246 16.0724 6.30796 16.5747L6.71602 16.6714C6.78403 16.6903 6.84984 16.7165 6.91786 16.7364C7.12628 16.7969 7.3314 16.8639 7.53543 16.9332C7.71533 16.9949 7.89195 17.0596 8.06854 17.1289C8.28136 17.2115 8.49306 17.2962 8.70148 17.3897C8.85724 17.46 9.00863 17.536 9.1611 17.6096C9.38048 17.7197 9.59328 17.8207 9.80171 17.9396C9.90262 17.9958 9.99697 18.0595 10.0957 18.1188C10.5392 18.3826 10.9677 18.6708 11.3791 18.9824C11.4888 19.0637 11.5985 19.1396 11.7005 19.2242C11.8881 19.3739 12.0658 19.5344 12.249 19.6949C12.3729 19.8049 12.4969 19.915 12.6153 20.0249C12.7821 20.1844 12.9444 20.3549 13.1013 20.5177C13.222 20.6452 13.3393 20.7761 13.4556 20.9081C13.6026 21.0775 13.7485 21.2468 13.8878 21.4229C14.0041 21.5713 14.1138 21.7232 14.2246 21.8759C14.3507 22.0497 14.4801 22.2202 14.5975 22.4006C14.7149 22.581 14.8169 22.7548 14.9266 22.9352C15.0933 23.2199 15.2557 23.5081 15.4016 23.8029C15.5113 24.0284 15.6286 24.2538 15.7306 24.4859C15.8052 24.6564 15.8689 24.8323 15.9358 25.0071C16.0191 25.2271 16.1014 25.4384 16.1738 25.6594C16.233 25.8388 16.2835 26.0202 16.3384 26.2028C16.4027 26.4316 16.4616 26.6617 16.515 26.8934C16.5567 27.0727 16.5961 27.2521 16.6301 27.4335C16.6784 27.693 16.7157 27.957 16.7497 28.221C16.7705 28.3805 16.7958 28.5377 16.8111 28.6982C16.8484 29.1063 16.8704 29.5177 16.8726 29.9357C16.8726 29.9544 16.8726 29.973 16.8726 29.9917V30.0027C16.8726 30.4426 16.8462 30.8825 16.8056 31.3226C16.7947 31.4325 16.7771 31.5425 16.7629 31.6602C16.7245 31.9902 16.6773 32.3059 16.617 32.6236C16.5928 32.7468 16.5654 32.8677 16.5391 32.9899C16.4696 33.3037 16.3903 33.6131 16.3011 33.9183C16.2703 34.0216 16.2407 34.1249 16.2078 34.2272C16.0945 34.5806 15.968 34.9274 15.8283 35.2677C15.8096 35.3128 15.7943 35.3589 15.7745 35.404C15.4338 36.2073 15.0177 36.9764 14.5317 37.7006C14.5163 37.7225 14.4999 37.7434 14.4856 37.7653C14.2619 38.0939 14.0242 38.4121 13.7726 38.7201C13.7364 38.7652 13.6991 38.8091 13.6629 38.8532C13.4194 39.1465 13.1634 39.4284 12.8951 39.6989C12.8633 39.7332 12.8314 39.7662 12.7985 39.799C11.8744 40.7177 10.8252 41.5005 9.68215 42.1241C9.65471 42.1394 9.62509 42.1528 9.59768 42.1681C9.25543 42.3522 8.90514 42.5215 8.5468 42.6763L8.34169 42.762C8.00968 42.8985 7.67146 43.0223 7.32702 43.1338C7.25242 43.158 7.18003 43.1832 7.10764 43.2064C7.01439 43.2351 6.92334 43.2701 6.82901 43.2965L6.40339 43.4066C6.26738 43.4406 6.12697 43.4671 5.99204 43.5089C5.9701 43.5155 5.94706 43.5155 5.92513 43.523C5.92153 43.5274 5.91644 43.5302 5.91088 43.5308C3.99361 44.1308 2.3541 45.3996 1.28934 47.1071C0.224566 48.8146 -0.195046 50.848 0.106512 52.839C0.40807 54.8302 1.41085 56.6469 2.93321 57.9607C4.45556 59.2742 6.39683 59.9975 8.40531 60H36.2861C39.1427 59.9992 41.9713 59.4334 44.6096 58.3352C47.2479 57.2369 49.6441 55.6274 51.6611 53.5991C53.6781 51.5708 55.2762 49.1635 56.364 46.5149C57.4516 43.8666 58.0077 41.0288 57.9999 38.1646L57.9572 21.7143Z"
                fill="url(#paint0_linear_363_1336)" />
              <g opacity="0.2">
                <path opacity="0.2"
                  d="M46.7802 33.7137H25.7803C24.8088 33.6969 23.8827 33.2982 23.2015 32.6033C22.5204 31.9084 22.1387 30.9731 22.1387 29.9988C22.1387 29.0246 22.5204 28.0892 23.2015 27.3945C23.8827 26.6997 24.8088 26.301 25.7803 26.2842H46.7802C47.7517 26.301 48.6778 26.6997 49.359 27.3945C50.0402 28.0892 50.4219 29.0246 50.4219 29.9988C50.4219 30.9731 50.0402 31.9084 49.359 32.6033C48.6778 33.2982 47.7517 33.6969 46.7802 33.7137Z"
                  fill="white" />
              </g>
              <path class="line-01"
                d="M46.0037 46.7576H38.8428C37.8713 46.7408 36.9452 46.3421 36.264 45.6472C35.5829 44.9524 35.2012 44.0172 35.2012 43.043C35.2012 42.0685 35.5829 41.1334 36.264 40.4385C36.9452 39.7436 37.8713 39.3449 38.8428 39.3281H46.0037C46.9752 39.3449 47.9013 39.7436 48.5825 40.4385C49.2637 41.1334 49.6454 42.0685 49.6454 43.043C49.6454 44.0172 49.2637 44.9524 48.5825 45.6472C47.9013 46.3421 46.9752 46.7408 46.0037 46.7576Z"
                fill="white" />
              <path class="line-02"
                d="M31.1551 20.6685H24.5734C24.0868 20.6685 23.6052 20.5724 23.1558 20.3859C22.7064 20.1991 22.298 19.9255 21.9539 19.5807C21.61 19.2357 21.3371 18.8264 21.1511 18.3756C20.9648 17.9251 20.869 17.4421 20.869 16.9543C20.869 16.4666 20.9648 15.9837 21.1511 15.5329C21.3371 15.0824 21.61 14.6728 21.9539 14.3281C22.298 13.9831 22.7064 13.7095 23.1558 13.5229C23.6052 13.3362 24.0868 13.2402 24.5734 13.2402H31.1551C31.6414 13.2402 32.1231 13.3362 32.5726 13.5229C33.022 13.7095 33.4305 13.9831 33.7743 14.3281C34.1184 14.6728 34.3911 15.0824 34.5774 15.5329C34.7636 15.9837 34.8593 16.4666 34.8593 16.9543C34.8593 17.4421 34.7636 17.9251 34.5774 18.3756C34.3911 18.8264 34.1184 19.2357 33.7743 19.5807C33.4305 19.9255 33.022 20.1991 32.5726 20.3859C32.1231 20.5724 31.6414 20.6685 31.1551 20.6685Z"
                fill="white" />
              <defs>
                <linearGradient id="paint0_linear_363_1336" x1="0.0027677" y1="29.9982" x2="57.9999" y2="29.9982"
                  gradientUnits="userSpaceOnUse">
                  <stop stop-color="#F93C34" />
                  <stop offset="1" stop-color="#D73C78" />
                </linearGradient>
              </defs>
            </svg>
          </div>
          <div class="process-content__status">
            <div v-if="end_status == 0" class="status status-1 is-active">
              Vytvárame tvoj DOFFERO účet
              <div class="dots">
                <span class="dot"></span><span class="dot"></span><span class="dot"></span>
              </div>
            </div>
            <div v-if="end_status == 1" class="status status-2 is-active">
              Nastavujeme vzhľad tvojich ponúk
              <div class="dots">
                <span class="dot"></span><span class="dot"></span><span class="dot"></span>
              </div>
            </div>
            <div v-if="end_status == 2" class="status status-3 is-active">
              Vytvárame tvoju prvú (ukážkovú) ponuku
              <div class="dots">
                <span class="dot"></span><span class="dot"></span><span class="dot"></span>
              </div>
            </div>
          </div>
        </div>
      </div>

    </v-app>
  </div>
</template>

<script>
import PricePlan from "../../admin/stripe/dashboard/components/PricePlan.vue";
import { VApp, VSelect, VBtn, VTooltip } from 'vuetify/lib'

export default {
  name: "AuthRegister",
  components: {
    PricePlan,
    VApp,
    VSelect,
    VBtn,
    VTooltip
  },
  props: [
    "email",
    "is_logged_in",
    "register_status",
    "register_data",
    "slugs",
    "companies",
    "users_count",
    "old_values",
    "input_errors",
    "session_id"
  ],
  data() {
    return {
      csrf: document
        .querySelector('meta[name="csrf-token"]')
        .getAttribute("content"),
      current_step: 0,
      loading: false,
      user: {
        meno_priezvisko: null,
        meno: null,
        priezvisko: null,
        email: null,
        password: null,
        password_conf: null,
        suhlas: false,
        _token: null,
        is_logged_in: false,
      },
      errors: {
        meno_priezvisko: "",
        meno: "",
        email: "",
        password: "",
        password_conf: "",
        suhlas: "",
        company_name: "",
        selectedBusiness: "",
        otherBusinessField: "",
        selectedEmployee: "",
        companyUrl: "",
      },
      focus_password: false,
      passowrd_errors: {
        znaky: false,
        number: false,
        letter: false,
      },
      emails: [],
      accepted: false,
      lang: this.$i18n.locale,
      // new properties for new onboarding
      currentStep: 0,
      step01: true,
      userType: 1, //default 1, can be 2
      isAfPayer: false,
      dphCheck: false,
      showExtendedFields: false,
      isShowedOverlay: true,
      companyDatas: {
        name: "",
        address: {
          zipCode: "",
          street: "",
          city: "",
        },
        ico: "",
        dic: "",
        dph: "",
        vatField: 23, // set base vat's value
      },
      employeeItems: [
        { id: 1, name: "1 človek" },
        { id: 2, name: "2-4 ľudia" },
        { id: 3, name: "5-10 ľudí" },
        { id: 4, name: "10 - 50 ľudí" },
        { id: 5, name: "50 a viac ľudí" },
      ],
      businessTypes: [
        { id: 1, name: "Stavebníctvo a remeselníctvo" },
        { id: 2, name: "Digitálna / marketingová agentúra" },
        { id: 3, name: "Maloobchod a predaj" },
        { id: 4, name: "Dizajn a grafika" },
        { id: 5, name: "IT, programovanie a softvér" },
        { id: 6, name: "Foto / video produkcia" },
        { id: 7, name: "Finančné poradenstvo a poisťovníctvo" },
        { id: 8, name: "Iné" },
      ],
      selectedEmployee: null,
      selectedBusiness: [], // more values can be selected
      showOtherInput: false,
      otherBusinessField: "", // iné extra field
      companyLogoImage: "",
      companyUrl: "",
      companyColor: "#CF5562", // default color
      showColorInput: false,
      employeeItemDefault: true,
      employeeItemNumber: 0,
      step: this.$route.params.step || 1,
      emailExistsError: false,
      end_status: 0,
    };
  },
  created() {
    //axios.post("/api/auth/emails").then((response) => {
    //   response.data.forEach((element) => {
    //     this.emails.push(element.email);
    //   });
    // });
    this.user.meno_priezvisko = this.old_values.meno_priezvisko || "";
    this.user.email = this.email;
    this.user.is_logged_in = this.is_logged_in;
    if (this.register_data && this.register_data.user) {
      this.populateUserData(this.register_data);
    }
    this.step = this.getStepFromRoute();
    this.checkRegisterStatus();
    if (this.input_errors['email']) {
      this.emailExistsError = true;

      this.errors.email = this.$t(
        "other_woutlog.validation_text_4"
      );
    }
  },
  mounted() {
    // start loading demo for step process last step
    this.startLoadingDemo();
  },
  methods: {
    populateUserData(data) {
      this.user.id = data.user.id;
      this.user.meno_priezvisko = data.user.meno + " " + data.user.priezvisko;
      this.user.meno = data.user.meno;
      this.user.priezvisko = data.user.priezvisko;
      this.user.email = data.user.email;
      this.userType = data.user.business_type ? data.user.business_type : 1;

      this.companyDatas.name = data.company.firma;
      this.companyDatas.address.zipCode = data.user.fa_psc;
      this.companyDatas.address.street = data.user.fa_address;
      this.companyDatas.address.city = data.user.fa_town;
      this.companyDatas.ico = data.user.fa_ico;
      this.companyDatas.dic = data.user.fa_dic;
      this.companyDatas.dph = data.user.fa_icdph;
      this.companyDatas.vatField = data.company.dph;
      this.selectedEmployee = data.company.employeeNumber;
      this.employeeItemNumber = data.company.employeeNumber;
      this.selectedBusiness = data.business_areas;
      if (data.otherBusinessField) {
        this.showOtherInput = true;
        this.otherBusinessField = data.otherBusinessField;
      }
    },
    fileInputTrigger() {
      document.querySelector("#fileInput").click();
    },
    filterSlug(value) {
      return value
        .toString()                  // Convert the value to a string
        .toLowerCase()               // Convert to lowercase
        .replace(/\s+/g, '-')        // Replace spaces with hyphens
        .replace(/[^a-z0-9-]/g, '')  // Remove all non-alphanumeric characters except hyphens
    },
    selectFileLogo($event) {
      let $self = this;
      const file = event.target.files[0];

      if (file && file.type.startsWith('image/')) {
        // Check if the file size is less than or equal to 2 MB (2 * 1024 * 1024 bytes)
        if (file.size <= 2 * 1024 * 1024) {
          var reader = new FileReader();
          reader.onload = function () {
            $self.companyLogoImage = reader.result;
          };
          reader.readAsDataURL(file);
        } else {
          this.$toast.warning("Obrázok musí byť menší ako 2 MB!", { timeout: 2500 });
        }
      } else {
        this.$toast.warning("Je možné nahrať iba obrázok!", { timeout: 2500 });
      }
    },
    startLoadingDemo() {
      let stepProcess = document.querySelector(".step-process");

      if (stepProcess) {
        let steps = document.querySelectorAll(".status");
        const stepsList = [...steps];

        let $i = 0;
        let testInt = setInterval(function () {
          stepsList.forEach((item) => {
            item.classList.remove("is-active");
          });
          stepsList[$i].classList.add("is-active");
          $i++;

          if ($i == stepsList.length) {
            clearInterval(testInt);
            stepsList[stepsList.length - 1].classList.add(
              "is-active"
            );
          }
        }, 2500);
      }
    },
    selectBusiness() {
      if (this.selectedBusiness.includes(8)) {
        this.showOtherInput = true;
      } else {
        this.showOtherInput = false;
      }
    },
    selectEmployee() {
      this.employeeItemNumber = this.selectedEmployee;
    },
    changeColor($event, $colorCode) {
      let allColors = document.querySelectorAll(".colors__item");

      allColors.forEach((colorItem) => {
        colorItem.classList.remove("is-active");
      });
      this.companyColor = $colorCode;
      event.target.classList.add("is-active");
    },
    check_email() {
      let hlp = 0;
      this.emailExistsError = false;
      this.emails.forEach((element) => {
        if (this.user.email == element) {
          hlp = 1;
          this.emailExistsError = true;
        }
      });
      return hlp;
    },
    error() {
      var hlp = true;
      this.emailExistsError = false;
      if (this.current_step == 0) {
        const emailRegex =
          /^([A-Za-z0-9_\-.])+@([A-Za-z0-9_\-.])+\.([A-Za-z]{2,10})$/;

        if (!this.user.meno_priezvisko) {
          this.errors.meno_priezvisko = this.$t(
            "other_woutlog.validation_text_1"
          );
          hlp = false;
        } else {
          this.errors.meno_priezvisko = "";
        }

        if (!this.user.email) {
          this.errors.email = this.$t(
            "other_woutlog.validation_text_2"
          );
          hlp = false;
        } else if (!emailRegex.test(this.user.email)) {
          this.errors.email = this.$t(
            "other_woutlog.validation_text_3"
          );
          this.emailExistsError = false;
          hlp = false;
        } else if (this.check_email()) {
          this.errors.email = this.$t(
            "other_woutlog.validation_text_4"
          );
          this.emailExistsError = true;
          hlp = false;
        } else {
          this.errors.email = "";
        }

        if (!this.user.password) {
          this.errors.password = this.$t(
            "other_woutlog.validation_text_5"
          );
          hlp = false;
        } else if (this.user.password.length < 8) {
          this.errors.password = this.$t(
            "other_woutlog.validation_text_6"
          );
          hlp = false;
        } else {
          this.errors.password = "";
        }

        if (!this.passowrd_errors.znaky) {
          hlp = false;
          $("#heslo").focus();
        } else if (!this.passowrd_errors.letter) {
          hlp = false;
          $("#heslo").focus();
        } else if (!this.passowrd_errors.number) {
          hlp = false;
          $("#heslo").focus();
        }

        if (!this.user.suhlas) {
          this.errors.suhlas = this.$t(
            "other_woutlog.validation_text_7"
          );
          hlp = false;
        } else {
          this.errors.suhlas = "";
        }
      } else if (this.current_step == 2) {
        if (!this.companyDatas.name) {
          this.errors.company_name = this.$t(
            "other_woutlog.validation_text_8"
          );
          hlp = false;
        } else {
          if (this.companies.includes(this.companyDatas.name)) {
            this.errors.company_name =
              "Tento názov spoločnosti sa už používa";
            hlp = false;
          } else {
            this.errors.company_name = "";
          }
        }
      } else if (this.current_step == 3) {
        if (!this.selectedBusiness.length) {
          this.errors.selectedBusiness =
            "Vyberte aspoň jeden typ podnikania";
          hlp = false;
        } else {
          this.errors.selectedBusiness = "";
          if (
            this.selectedBusiness.includes(8) &&
            !this.otherBusinessField
          ) {
            this.errors.otherBusinessField =
              "Prosím, zadajte hodnotu pre iné podnikanie";
            hlp = false;
          } else {
            this.errors.otherBusinessField = "";
          }
        }
        if (!this.selectedEmployee) {
          this.errors.selectedEmployee = "Vyberte počet zamestnancov";
          hlp = false;
        } else {
          this.errors.selectedEmployee = "";
        }
      } else if (this.current_step == 4) {
        if (!this.companyUrl) {
          this.errors.companyUrl =
            "Prosím, zadajte URL adresu spoločnosti";
          hlp = false;
        } else {
          if (this.slugs.includes(this.companyUrl)) {
            this.errors.companyUrl =
              "Táto URL adresa spoločnosti je už obsadená";
            hlp = false;
          } else {
            this.errors.companyUrl = "";
          }
        }
      }

      return hlp;
    },
    save(event) {
      if (this.current_step == 0) {
        if (!this.error()) {
          event.preventDefault();
        } else {
          this.saveStepZero();
        }
      } else if (this.current_step == 1) {
        this.saveStepTwo();
      } else if (this.current_step == 2) {
        if (this.error()) {
          this.saveStepThree();
        }
      } else if (this.current_step == 3) {
        if (this.error()) {
          this.saveStepFour();
        }
      } else if (this.current_step == 4) {
        if (this.error()) {
          this.saveStepFive();
        }
      }
    },
    saveStepZero() {
      var name = this.user.meno_priezvisko.split(" ");
      this.user.meno = name[0];
      this.user.priezvisko = name[1];
      this.user._token = this.csrf;
      if (this.user.meno && this.user.email && this.user.password) {
        this.loading = true;
        const gtmEventData = {
          event: "register_account",
          "Event category": "registration",
          "Event action": "register_account",
        };
        this.$gtm.push(gtmEventData);
      }
    },
    saveStepTwo() {
      // userType = 1 -> podnikatel, userType = 2 -> nie som podnikatel
      if (this.userType) {
        this.loading = true;
        axios
          .post("/api/register/typ-uctu", {
            userType: this.userType,
            is_logged_in: this.is_logged_in,
            user_email: this.user.email
          })
          .then((response) => {
            this.loading = false;
            this.$router.push("/registracia/firma");
            this.current_step = 2;
            window.scrollTo(0, 0);
          })
          .catch((error) => {
            console.log(error);
          });
      }
    },
    saveStepThree() {
      if (this.companyDatas.name) {
        this.loading = true;
        this.companyDatas["dphCheck"] = this.dphCheck;
        this.companyDatas["is_logged_in"] = this.is_logged_in;
        this.companyDatas["user_email"] = this.user.email;
        axios
          .post("/api/register/firma", this.companyDatas)
          .then((response) => {
            this.loading = false;
            this.$router.push("/registracia/viac-info");
            this.current_step = 3;
            window.scrollTo(0, 0);
          })
          .catch((error) => {
            console.log(error);
          });
      }
    },
    saveStepFour() {
      this.loading = true;
      axios
        .post("/api/register/viac-info", {
          business_area: this.selectedBusiness,
          business_area_ine: this.otherBusinessField,
          employeeItemNumber: this.employeeItemNumber,
          is_logged_in: this.is_logged_in,
          user_email: this.user.email
        })
        .then((response) => {
          this.loading = false;
          this.$router.push("/registracia/dizajn");
          this.current_step = 4;
          window.scrollTo(0, 0);
        })
        .catch((error) => {
          console.log(error);
        });
    },
    saveStepFive() {
      this.loading = true;
      axios
        .post("/api/register/dizajn", {
          companyLogoImage: this.companyLogoImage,
          slug: this.companyUrl,
          offerColor: this.companyColor,
          is_logged_in: this.is_logged_in,
          user_email: this.user.email
        })
        .then((response) => {
          this.loading = false;
          // check if there is a plan in session storage
          if (localStorage.getItem('plan')) {
            let data = JSON.parse(localStorage.getItem('plan'));
            if(data.plan.name == "Zadarmo") {
              localStorage.removeItem('plan');
              this.freePlanSelected();
              return;
            }
            this.createCheckoutSession(data.plan, data.billingCycle);
            return;
          }
          this.$router.push("/registracia/cennik");
          this.current_step = 5;
          window.scrollTo(0, 0);
        })
        .catch((error) => {
          console.log(error);
        });
    },
    freePlanSelected() {
      this.current_step = 6;
      this.end_status = 1;
      axios
        .post("/api/register/cennik", {
          free_plan: true,
          is_logged_in: this.is_logged_in,
          user_email: this.user.email,
          user_id: this.user.id
        })
        .then((response) => {
          const gtmEventData = {
            event: "registration_setup_finished",
            "Event category": "registration_setup_finished",
            "Event action":
              "successfull_registration_setup_finished",
            "Event label": "free"
          };
          this.$gtm.push(gtmEventData);
          setTimeout(() => {
            this.end_status = 2;
          }, 2000);
          setTimeout(() => {
            window.location.href = "/admin";
          }, 4000);
        })
        .catch((error) => {
          console.log(error);
        });
    },
    saveFinalStep() {
      this.current_step = 6;
      this.end_status = 1;
      axios
        .post("/api/register/cennik", {
          session_id: this.session_id,
          is_logged_in: this.is_logged_in,
          user_email: this.user.email,
          user_id: this.user.id
        })
        .then((response) => {
          const gtmEventData = {
            event: "registration_setup_finished",
            "Event category": "registration_setup_finished",
            "Event action":
              "successfull_registration_setup_finished",
            "Event label": "premium"
          };
          this.$gtm.push(gtmEventData);
          setTimeout(() => {
            this.end_status = 2;
          }, 2000);
          setTimeout(() => {
            window.location.href = "/admin";
          }, 4000);
        })
        .catch((error) => {
          console.log(error);
        });
    },
    checkRegisterStatus() {
      const statusToRouteMap = {
        1: "/registracia/typ-uctu",
        2: "/registracia/firma",
        3: "/registracia/viac-info",
        4: "/registracia/dizajn",
        5: "/registracia/cennik",
      };
      const targetRoute =
        statusToRouteMap[this.register_status] || "/registracia";
      if (this.$route.path !== targetRoute) {
        this.$router.push(targetRoute);
      }
      this.step = this.getStepFromRoute();
    },
    getStepFromRoute() {
      if (this.$route.path === "/registracia") {
        this.current_step = 0;
        return "start";
      } else if (this.$route.path === "/registracia/typ-uctu") {
        this.current_step = 1;
        return "account-type";
      } else if (this.$route.path === "/registracia/firma") {
        this.current_step = 2;
        return "company";
      } else if (this.$route.path === "/registracia/viac-info") {
        this.current_step = 3;
        return "more-info";
      } else if (this.$route.path === "/registracia/dizajn") {
        this.current_step = 4;
        return "design";
      }else if (this.$route.path === "/registracia/cennik" && this.session_id) {
        this.saveFinalStep();
        return "final";
      } else if (this.$route.path === "/registracia/cennik") {
        this.current_step = 5;
        return "pricing";
      }
      return "start";
    },
    createCheckoutSession(plan, billingCycle) {
      let priceId = billingCycle == 'yearly' ? plan.yearID : plan.monthID;
      axios
        .post("/api/stripe/create-checkout-session-without-payment", {
            discount: sessionStorage.getItem('digiuni_discount') && billingCycle == 'yearly',
            price_id: priceId,
            user_id: this.user.id,
        })
        .then((response) => {
            localStorage.removeItem('plan');
            window.location.href = response.data.url;
      });
      return;
    },
    // remap comapny_datasa to invoice_details
    remapCompanyDatasToInvoiceDetails() {
      return {
        'name': this.companyDatas.name,
        'ico': this.companyDatas.ico,
        'dic': this.companyDatas.dic,
        'ic_dph': this.companyDatas.dph,
        'address': this.companyDatas.address.street,
        'zip': this.companyDatas.address.zipCode,
        'town': this.companyDatas.address.city,
      };
    },
  },
  watch: {
    "selectedEmployee"() {
      this.employeeItemNumber = this.selectedEmployee
    },
    "companyDatas.vatField"() {
      if (this.companyDatas.vatField !== null && !this.dphCheck) {
        this.dphCheck = true;
      }
      if (this.companyDatas.vatField === "") {
        this.companyDatas.vatField = 0;
      }
    },
    "companyDatas.dph"() {
      if (this.companyDatas.dph != null)
        this.dphCheck = true
      if (this.companyDatas.dph == null)
        this.dphCheck = false
      if (this.companyDatas.dph == "")
        this.dphCheck = false
    },
    dphCheck() {
      if (this.dphCheck) {
        this.companyDatas.vatField = 23;
      } else {
        this.companyDatas.vatField = null;
      }
    },
    "$route.path"() {
      this.step = this.getStepFromRoute();
    },
    "user.email": function () {
      if (this.user.email.length > 0) {
        $(".input-wrapper.email label").addClass("is-jumped");
      }
    },
    "user.password": function () {
      if (this.focus_password) {
        this.passowrd_errors.znaky = false;
        this.passowrd_errors.number = false;
        this.passowrd_errors.letter = false;
        if (this.user.password.length >= 8) {
          this.passowrd_errors.znaky = true;
        }
        if (/\d/.test(this.user.password)) {
          this.passowrd_errors.number = true;
        }
        if (/[A-Z]/.test(this.user.password)) {
          this.passowrd_errors.letter = true;
        }
        this.errors.password = "";
      }
      if (this.user.password.length > 0) {
        $(".input-wrapper.password label").addClass("is-jumped");
      }
    },
    "companyDatas.name": function () {
      if (this.companyDatas.name) {
        this.errors.company_name = "";
        this.companyUrl = this.filterSlug(this.companyDatas.name);
      }
    },
    selectedBusiness: function () {
      if (this.selectedBusiness.length) {
        this.errors.selectedBusiness = "";
      }
    },
    selectedEmployee: function () {
      if (this.selectedEmployee) {
        this.errors.selectedEmployee = "";
      }
    },
    companyUrl: function () {
      if (this.companyUrl) {
        this.errors.companyUrl = "";
        this.companyUrl = this.filterSlug(this.companyUrl);
      }
    },
    otherBusinessField: function () {
      if (this.otherBusinessField) {
        this.errors.otherBusinessField = "";
      }
    },
  },
};
</script>

<style lang="scss">
.checkbox-wrapper-28 {
  --size: 16px;
  position: relative;
}

.checkbox-wrapper-28 *,
.checkbox-wrapper-28 *:before,
.checkbox-wrapper-28 *:after {
  box-sizing: border-box;
}

.checkbox-wrapper-28 .promoted-input-checkbox {
  border: 0;
  clip: rect(0 0 0 0);
  height: 1px;
  margin: -1px;
  overflow: hidden;
  padding: 0;
  position: absolute;
  width: 1px;
}

.checkbox-wrapper-28 input:checked ~ svg {
  height: calc(var(--size) * 0.6);
  -webkit-animation: draw-checkbox-28 ease-in-out 0.2s forwards;
          animation: draw-checkbox-28 ease-in-out 0.2s forwards;
}
.checkbox-wrapper-28 label:active::after {
  background-color: #e6e6e6;
}
.checkbox-wrapper-28 label {
  color: #F93C34;
  line-height: var(--size);
  cursor: pointer;
  position: relative;
}
.checkbox-wrapper-28 label:after {
  content: "";
  height: var(--size);
  width: var(--size);
  margin-right: 8px;
  float: left;
  border: 2px solid #F93C34;
  border-radius: 3px;
  transition: 0.15s all ease-out;
}
.checkbox-wrapper-28 svg {
  stroke: #F93C34;
  stroke-width: 3px;
  height: 0;
  width: calc(var(--size) * 0.6);
  position: absolute;
  left: calc(var(--size) * 0.21);
  top: calc(var(--size) * 0.2);
  stroke-dasharray: 33;
}

@-webkit-keyframes draw-checkbox-28 {
  0% {
    stroke-dashoffset: 33;
  }
  100% {
    stroke-dashoffset: 0;
  }
}

@keyframes draw-checkbox-28 {
  0% {
    stroke-dashoffset: 33;
  }
  100% {
    stroke-dashoffset: 0;
  }
}
.v-menu {
  display: block !important;
}

.v-list-item {
  gap: 20px !important;
}

.process-content__graphics {
  display: flex !important;
  justify-content: center !important;
}
</style>
<style lang="scss" scoped>
.v-menu {
  display: block !important;
}

.v-list-item--link {
  gap: 20px !important;
}

#companyName:autofill,
#companyName:-webkit-autofill,
#companyName:-webkit-autofill:hover,
#companyName:-webkit-autofill:focus,
#companyName:-webkit-autofill:active {
  border: 1px solid #e0e0e1;
}

#meno:autofill,
#meno:-webkit-autofill,
#meno:-webkit-autofill:hover,
#meno:-webkit-autofill:focus,
#meno:-webkit-autofill:active {
  border: 1px solid #e0e0e1;
}

#meno:autofill,
#email:-webkit-autofill,
#email:-webkit-autofill:hover,
#email:-webkit-autofill:focus,
#email:-webkit-autofill:active {
  border: 1px solid #e0e0e1;
}

.loading-indicator {
  display: flex;
  justify-content: center;
  align-items: center;
  position: relative;
  width: 133px;
}

.circle {
  width: 8px;
  height: 8px;
  margin: 0 2px;
  background-color: white;
  border-radius: 50%;
  animation: loading 0.6s infinite alternate;
}

.circle:nth-child(1) {
  animation-delay: 0s;
}

.circle:nth-child(2) {
  animation-delay: 0.2s;
}

.circle:nth-child(3) {
  animation-delay: 0.4s;
}

@keyframes loading {
  from {
    transform: scale(1);
    opacity: 1;
  }

  to {
    transform: scale(1.5);
    opacity: 0.5;
  }
}

.btn_loading {
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 0.85rem;
  padding: 14px 20px;
  border-radius: 8px;
  background: #f93c34;
  color: #fff;
  width: 100%;
  height: 57px;
}

.password_errors {
  display: flex;
  align-items: center;
  margin-top: 10px;

  span {
    display: flex;
    align-items: flex-start;
    font-size: 14px;
    color: #e83c58;
    margin-right: 20px;

    svg {
      width: 16px;
      height: 13px;
      margin-right: 5px;
    }
  }

  span.active {
    color: #34d399;
  }
}

button {
  cursor: pointer;
  color: #fff !important;
}

.lds-ellipsis {
  display: inline-block;
  position: relative;
  width: 80px;
  height: 80px;
}

.lds-ellipsis div {
  position: absolute;
  top: 33px;
  width: 13px;
  height: 13px;
  border-radius: 50%;
  background: #fff;
  animation-timing-function: cubic-bezier(0, 1, 1, 0);
}

.lds-ellipsis div:nth-child(1) {
  left: 8px;
  animation: lds-ellipsis1 0.6s infinite;
}

.lds-ellipsis div:nth-child(2) {
  left: 8px;
  animation: lds-ellipsis2 0.6s infinite;
}

.lds-ellipsis div:nth-child(3) {
  left: 32px;
  animation: lds-ellipsis2 0.6s infinite;
}

.lds-ellipsis div:nth-child(4) {
  left: 56px;
  animation: lds-ellipsis3 0.6s infinite;
}

@keyframes lds-ellipsis1 {
  0% {
    transform: scale(0);
  }

  100% {
    transform: scale(1);
  }
}

@keyframes lds-ellipsis3 {
  0% {
    transform: scale(1);
  }

  100% {
    transform: scale(0);
  }
}

@keyframes lds-ellipsis2 {
  0% {
    transform: translate(0, 0);
  }

  100% {
    transform: translate(24px, 0);
  }
}

.v-menu__content {
  display: block !important;
  z-index: 1000;
}

/* Ensure the select dropdown is visible and properly positioned */
.v-select__content.v-menu__content {
  position: absolute !important;
  display: block !important;
  opacity: 1 !important;
  pointer-events: auto !important;
}
</style>
